import { __decorate, __param } from '../node_modules/tslib/tslib.es6.js';
import '../vscode-services/missing-services.js';
import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { IWorkbenchLayoutService } from '../vscode/vs/workbench/services/layout/browser/layoutService.js';
import { ILayoutService } from 'monaco-editor/esm/vs/platform/layout/browser/layoutService.js';
import { Event, Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { ICodeEditorService } from 'monaco-editor/esm/vs/editor/browser/services/codeEditorService.js';
import * as dom from 'monaco-editor/esm/vs/base/browser/dom.js';
import { isAncestorUsingFlowTo } from 'monaco-editor/esm/vs/base/browser/dom.js';
import { SyncDescriptor } from 'monaco-editor/esm/vs/platform/instantiation/common/descriptors.js';
import { IPaneCompositePartService } from '../vscode/vs/workbench/services/panecomposite/browser/panecomposite.js';
let LayoutService = class LayoutService {
    constructor(container, paneCompositeService) {
        this.container = container;
        this.paneCompositeService = paneCompositeService;
        this.onDidChangeFullscreen = Event.None;
        this.parts = new Map();
        this.hiddenParts = new Set();
        this._onDidChangePartVisibility = new Emitter();
        this.onDidChangePartVisibility = this._onDidChangePartVisibility.event;
        this.offset = { top: 0, quickPickTop: 0 };
        this._onDidLayout = new Emitter();
        this.onDidLayout = this._onDidLayout.event;
        window.addEventListener('resize', () => this.layout());
        this.layout();
    }
    getMaximumEditorDimensions() {
        return new dom.Dimension(Infinity, Infinity);
    }
    isPanelMaximized() {
        return false;
    }
    getPanelPosition() {
        return 2 ;
    }
    hasFocus(part) {
        const activeElement = document.activeElement;
        if (activeElement == null) {
            return false;
        }
        const container = this.getContainer(part);
        return !(container == null) && isAncestorUsingFlowTo(activeElement, container);
    }
    getContainer(part) {
        if (this.parts.get(part) == null) {
            return undefined;
        }
        return this.getPart(part).getContainer();
    }
    getPart(key) {
        const part = this.parts.get(key);
        if (part == null) {
            throw new Error(`Unknown part ${key}`);
        }
        return part;
    }
    setPartHidden(hidden, part) {
        if (hidden) {
            this.hiddenParts.add(part);
        }
        else {
            this.hiddenParts.delete(part);
        }
        this._onDidChangePartVisibility.fire();
        const location = {
            ["workbench.parts.sidebar" ]: 0 ,
            ["workbench.parts.auxiliarybar" ]: 2 ,
            ["workbench.parts.panel" ]: 1
        }[part];
        if (location != null) {
            const paneComposite = this.paneCompositeService.getActivePaneComposite(location);
            if (paneComposite != null) {
                if (hidden) {
                    this.paneCompositeService.hideActivePaneComposite(location);
                }
            }
            if (this.paneCompositeService.getPartByLocation != null) {
                this.paneCompositeService.getPartByLocation(location).setVisible(!hidden);
            }
        }
        setTimeout(() => {
            this.setPartHidden(false, part);
        });
    }
    isVisible(part) {
        return !( this.hiddenParts.has(part));
    }
    getSideBarPosition() {
        return 0 ;
    }
    registerPart(part) {
        this.parts.set(part.getId(), part);
    }
    isRestored() {
        return true;
    }
    get dimension() { return this._dimension; }
    layout() {
        this._dimension = dom.getClientArea(window.document.body);
        this._onDidLayout.fire(this._dimension);
    }
    get hasContainer() {
        return true;
    }
    focus() {
        StandaloneServices.get(ICodeEditorService).getFocusedCodeEditor()?.focus();
    }
};
LayoutService = __decorate([
    ( __param(1, IPaneCompositePartService))
], LayoutService);
function getServiceOverride(container = document.body) {
    container.classList.add('monaco-workbench');
    return {
        [( ILayoutService.toString())]: new SyncDescriptor(LayoutService, [container]),
        [( IWorkbenchLayoutService.toString())]: new SyncDescriptor(LayoutService, [container])
    };
}
export { LayoutService, getServiceOverride as default };
